<div class="modal active displaySettings">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2 class="title">Display Settings</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngDisplayForm" #ngForm="ngForm" id="displayForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Graphical Options</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Map Background</label>
                  <div>
                    <span style="width: 20%; display: block; margin-right: 10px;">{{ this.configurationController.currentConfiguration.display.mapBackground}}</span>
                    <!-- <input
                    [style.background]="this.configurationController.currentConfiguration.display.mapBackground"
                    [cpOKButton]="true"
                    [cpSaveClickOutside]="false"
                    [(colorPicker)]="this.configurationController.currentConfiguration.display.mapBackground"
                    [cpOutputFormat]="'rgba'"
                    [cpOKButtonClass]= "'blue'"
                    [cpPresetColors]="['#ffffff']"
                    name="lineColor"
                    id="mapBackground"
                    style="border-width: 1px;"
                    /> -->
                    <input style="width: 35px !important;" type="color" id="mapBackground" list="presetColors" name="lineColor" value={{this.configurationController.currentConfiguration.display.mapBackground}} [(ngModel)]="this.configurationController.currentConfiguration.display.mapBackground">
                    <datalist id="presetColors">
                      <option value="#ff0000">
                      <option value="#FFFF00">
                      <option value="#66FF66">
                      <option value="#00ff00">
                      <option value="#00ffff">
                        <option value="#0000ff">
                        </datalist>
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Coordinate Format</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Coordinate Format</label>
                  <select
                    [(ngModel)]="this.configurationController.currentConfiguration.display.coordinateFormat"
                    name="coordinateFormat"
                    id="coordinateFormat"
                  >
                    <option value="Decimal">Decimal Degrees</option>
                    <option value="DMS">Degrees Minutes Seconds</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Display Units</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Horizontal Units</label>
                  <select
                    [(ngModel)]="this.configurationController.currentConfiguration.display.horizontalUnits"
                    name="horizontalUnits"
                    id="horizontalUnits"
                  >
                    <option value="NM">Nautical Miles(NM)</option>
                    <option value="m">Meters (m)</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Start Options</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <input type="checkbox"
                    [(ngModel)]="this.configurationController.currentConfiguration.display.startDefaultArea"
                    [checked]="this.configurationController.currentConfiguration.display.startDefaultArea"
                    name="startDefaultArea"
                    id="startDefaultArea"/>
                    <label for="" style="width: initial !important;">Start on default area of interest</label>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__block">

          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="saveConfiguration()" [disabled]="!ngForm.form.valid">
              Save
            </button>
            <button type="submit" [ngClass]="ngForm.valid ? 'blue' : 'gray'" (click)="retoreDefaults();">
              Restore Defaults
            </button>
            <button class="gray" (click)="cancelConfiguration()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
